import { apiService } from './apiService';

export const vehicleService = {
  // Get all vehicles
  async getVehicles(params?: { type?: string; status?: string; ownerType?: string; externalTransportAccountUserId?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.type) queryParams.append('type', params.type);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.ownerType) queryParams.append('ownerType', params.ownerType);
    if (params?.externalTransportAccountUserId) queryParams.append('externalTransportAccountUserId', params.externalTransportAccountUserId);
    
    const query = queryParams.toString();
    return await apiService.get(`/vehicles${query ? `?${query}` : ''}`);
  },

  // Get vehicle by ID
  async getVehicle(id: string | number) {
    return await apiService.get(`/vehicles/${id}`);
  },

  // Create vehicle
  async createVehicle(data: any) {
    return await apiService.post('/vehicles', data);
  },

  // Update vehicle
  async updateVehicle(id: string | number, data: any) {
    return await apiService.put(`/vehicles/${id}`, data);
  },

  // Delete vehicle
  async deleteVehicle(id: string | number) {
    return await apiService.delete(`/vehicles/${id}`);
  },

  // Get vehicle assignments
  async getAssignments(params?: { vehicleId?: string; driverId?: string; startDate?: string; endDate?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.vehicleId) queryParams.append('vehicleId', params.vehicleId);
    if (params?.driverId) queryParams.append('driverId', params.driverId);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    
    const query = queryParams.toString();
    return await apiService.get(`/vehicle-assignments${query ? `?${query}` : ''}`);
  },

  // Create assignment
  async createAssignment(data: any) {
    return await apiService.post('/vehicle-assignments', data);
  },

  // Update assignment
  async updateAssignment(id: string | number, data: any) {
    return await apiService.put(`/vehicle-assignments/${id}`, data);
  },

  // Delete assignment
  async deleteAssignment(id: string | number) {
    return await apiService.delete(`/vehicle-assignments/${id}`);
  },
};
